export default {
  qrCodeList: (state) => state.qrCodeList,
  qrCodeCount: (state) => state.qrCodeCount,
  qrList: (state) => state.qrList,
  qrCount: (state) => state.qrCount,
  qrDetail: (state) => state.qrDetail,
  qrShops: (state) => state.qrShops,
}